import { DOCUMENT_DICT, ONBOARDING_BUSINESS_DICT } from '@/constants';
import { i18n } from '@/i18n';
import { DocumentWrapper, UnionDocument } from '@/types/interfaces';
import { OnboardingDocument } from '@/types/interfaces/Document.interface';

export function getOptionsList<T extends keyof typeof ONBOARDING_BUSINESS_DICT>(
  valuesName: T,
  localizeLabel: boolean = false,
): { label: string; value: string }[] {
  return ONBOARDING_BUSINESS_DICT[valuesName].map((value) => {
    const label = `entity.${valuesName}.${value}`;
    return {
      label: localizeLabel ? i18n.global.t(label) : label,
      value,
    };
  });
}

export function getCustomOptionsList<T extends keyof typeof ONBOARDING_BUSINESS_DICT>(
  dict: string[],
  valuesName: T,
  localizeLabel: boolean = false,
): { label: string; value: string }[] {
  return dict.map((value) => {
    const label = `entity.${valuesName}.${value}`;
    return {
      label: localizeLabel ? i18n.global.t(label) : label,
      value,
    };
  });
}

export function getDocumentsOptionList<T extends keyof typeof DOCUMENT_DICT>(
  valuesName: T,
  uploadedDocumentList: Record<UnionDocument, OnboardingDocument>,
): DocumentWrapper<typeof DOCUMENT_DICT[T][number]>[] {
  return DOCUMENT_DICT[valuesName].map((type) => ({
    label: `entity.${valuesName}.${type}`,
    type,
    isUploaded: !!uploadedDocumentList[type],
  }));
}
